export default "__VITE_ASSET__51ada3bc__"